import React from 'react'
import Header from './Header'
import Meme from './Meme'
import './Styles.css'


function App() {
    return (
        <div>
            <Header />
            <Meme />
        </div>
    )
}

export default App
